import React from "react";
import { Dropdown } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./styles.css";
const { Menu, Item } = Dropdown;

const Arrays = (props) => {
  const { index, setIndex, categories } = props;
  return (
    <Dropdown
      text={
        <h6
          className={`${index ? "text-white" : "text-dark"} font-weight-bold`}
        >
          ARREGLOS
        </h6>
      }
      className={`${index ? "text-white" : "text-dark"} font-weight-bold`}
      simple
      item
    >
      <Menu
        style={{
          backgroundColor: index ? "transparent" : "white",
          backgroundImage: index
            ? "linear-gradient(to bottom, transparent, #3B3B3B)"
            : null,
        }}
      >
        <Item as={Link} to={`/products/Todos`} onClick={() => setIndex(false)}>
          <h6
            className={`${index ? "text-white" : "text-dark"} font-weight-bold`}
          >
            Todos los arreglos
          </h6>
        </Item>
        {categories.map((category) => (
          <Item
            key={category.id}
            as={Link}
            to={`/products/${category.id}`}
            onClick={() => setIndex(false)}
          >
            <h6
              className={`${
                index ? "text-white" : "text-dark"
              } font-weight-bold`}
            >
              {category.data.name}
            </h6>
          </Item>
        ))}
      </Menu>
    </Dropdown>
  );
};
export default Arrays;
